import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DialogActions,
  DialogContent,
} from './DateTimePickerContent.styled';
import DateTimePicker from '../../../DateTimePicker/DateTimePicker';

const DateTimePickerContent = ({
  onClose,
  date,
  primaryAction,
  secondaryAction,
  DateTimePickerProps,
}) => {
  const [selectedDate, setSelectedDate] = useState(
    date ? new Date(date) : new Date()
  );

  const handlePrimaryActionClick = () => {
    onClose();
    primaryAction.onAction(selectedDate.toISOString());
  };

  const handleSecondaryActionClick = () => {
    onClose();
    if (secondaryAction) {
      secondaryAction.onAction();
    }
  };

  const secondary = secondaryAction ? (
    <Button onClick={handleSecondaryActionClick} data-testid="secondary-button">
      {secondaryAction.label}
    </Button>
  ) : null;

  return (
    <div>
      <DialogContent>
        <DateTimePicker
          date={selectedDate}
          onChange={setSelectedDate}
          minDate={DateTimePickerProps.minDate}
          maxDate={DateTimePickerProps.maxDate}
          disablePast={!!DateTimePickerProps.disablePast}
          disableFuture={!!DateTimePickerProps.disableFuture}
          dateOnly={DateTimePickerProps.dateOnly}
        />
      </DialogContent>
      <DialogActions>
        {secondary}
        <Button onClick={handlePrimaryActionClick} data-testid="primary-button">
          {primaryAction.label}
        </Button>
      </DialogActions>
    </div>
  );
};

const ActionType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
});

DateTimePickerContent.propTypes = {
  /** Dialog title ID */
  titleId: PropTypes.string.isRequired,

  /** On dialog close callback */
  onClose: PropTypes.func,

  /** Default selected date */
  date: PropTypes.string,

  /** Dialog primary action config */
  primaryAction: ActionType.isRequired,

  /** Dialog secondary action config */
  secondaryAction: ActionType,

  /** Props to be sent to the DateTimePicker component */
  DateTimePickerProps: PropTypes.shape({
    /** Disable past dates selections */
    disablePast: PropTypes.bool,

    /** Disable future dates selections */
    disableFuture: PropTypes.bool,

    /** Minimum selectable date */
    minDate: PropTypes.string,

    /** Maximum selectable date */
    maxDate: PropTypes.string,

    /** Date-only selection */
    dateOnly: PropTypes.bool.isRequired,
  }),
};

DateTimePickerContent.defaultProps = {
  date: null,
  secondaryAction: null,
  onClose: () => {},
  DateTimePickerProps: {},
  disablePast: false,
  disableFuture: false,
  minDate: null,
  maxDate: null,
};

export default DateTimePickerContent;
